// extracted by mini-css-extract-plugin
export default {"title_price_container":"title_price_title_price_container__jvC49"};